export default __webpack_public_path__ + "static/media/call-center.ad268bbf.png";